/**
 * `tone="accent"` is the default because a meter usually means "something is
 * running out". A *finished* progress bar is not an alarm, so completed work
 * fills in ink — the accent stays a rare signal, per the brand's tone.
 */
export function Meter({ ratio, tone = 'accent' }: { ratio: number; tone?: 'accent' | 'ink' }) {
	const pct = Math.min(100, Math.round(ratio * 100))
	return (
		<div
			className="h-2 w-full overflow-hidden rounded-full border border-line-strong bg-paper"
			role="progressbar"
			aria-valuenow={pct}
			aria-valuemin={0}
			aria-valuemax={100}
		>
			<div
				className={'h-full transition-all ' + (tone === 'ink' ? 'bg-ink' : 'bg-marigold')}
				style={{ width: `${pct}%` }}
			/>
		</div>
	)
}
